import React from "react";

const LEVELS = [
  { label: "High",   dot: "bg-green-500",  count: 3 },
  { label: "Medium", dot: "bg-yellow-500", count: 1 },
  { label: "Low",    dot: "bg-red-500",    count: 2 },
];

export default function ConfidenceBreakdown() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 flex flex-col gap-4">
      <p className="text-sm font-semibold text-slate-800">Confidence breakdown</p>

      <div className="flex flex-col gap-2">
        {LEVELS.map(({ label, dot, count }) => (
          <div key={label} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className={`w-2.5 h-2.5 rounded-full ${dot}`} />
              <span className="text-sm text-slate-700">{label}</span>
            </div>
            <span className="text-sm font-semibold text-slate-800">{count}</span>
          </div>
        ))}
      </div>

      <div className="flex rounded-full overflow-hidden h-2">
        <div className="bg-green-500  h-2 rounded-l-full" style={{ width: "50%" }} />
        <div className="bg-yellow-400 h-2"                style={{ width: "17%" }} />
        <div className="bg-red-500    h-2 rounded-r-full" style={{ width: "33%" }} />
      </div>

      <p className="text-xs text-slate-500 leading-relaxed">
        Focus your review on the 2 low-confidence items. They were inferred from documentation rather than code.
      </p>
    </div>
  );
}
